import { FunctionComponent, MouseEventHandler } from 'react'
import getUrl from 'front-end-core/core/url'
import cx from 'classnames'
import selectController from 'redux/selectors/selectController'
import { useSelector } from 'react-redux'
import { SEARCH } from 'constants/controllers'
import selectAolName from 'redux/selectors/selectAolName'
import selectFlavour from 'redux/selectors/selectFlavour'
import { AOLMenu } from 'interfaces/aol'
import FiberNewIcon from '@material-ui/icons/FiberNew'
import selectSearchType from 'redux/selectors/selectSearchType'

const MenuLink:FunctionComponent<MenuLinkProps> = ({
  title,
  target: _target,
  url,
  params,
  onClick,
  activeClass = '',
  isNew = false,
  highlightPages = [],
  searchType,
  externalLink,
}) => {
  const flavour = useSelector(selectFlavour)
  const aol = useSelector(selectAolName)
  const controller = useSelector(selectController)
  const currentSearchType = useSelector(selectSearchType)

  const href = url || getUrl(_target, { aol, flavour, ...params })

  let active

  if (controller === SEARCH) {
    active = searchType === currentSearchType
  } else {
    active = highlightPages.includes(controller)
  }

  const className = cx(
    'no-underline nowrap f4 fw6 basis-auto grow-0 shrink-0 tc outline-0 focus-outline-0 mr7 bb-medium b--transparent flex items-center',
    {
      'black hover-b--black': !active,
      [activeClass]: active,
      'hover-b--inherit': active && controller === SEARCH
    }
  )

  const target = externalLink ? '_blank' : '_self'

  return (
    <a
      {...{ href, className, onClick, target }}
      tabIndex={-1}
      data-event-category='Main Menu'
      data-event-action='Select'
      data-event-label={title}
    >
      <div className='pr4'>{title}</div>
      {isNew && <FiberNewIcon fontSize='small' />}
    </a>
  )
}

interface MenuLinkProps extends AOLMenu {
  onClick: MouseEventHandler<HTMLAnchorElement>,
  currentPageId: string | null
}

export default MenuLink
